/** Pure QC step defaults shared by the QC pages and their loading skeleton. */
import type { QcStep } from '../../utils/qc-steps';

/** Every step on — what the strip shows before the run says which steps it has. */
export const QC_ALL_STEPS: Record<QcStep, boolean> = {
  setup: true,
  run: true,
  review: true,
  scores: true,
  summary: true,
};
